import { hashFunction } from './hashFunction.js';
export const getEventSelector = (event) => hashFunction(event);
//# sourceMappingURL=getEventSelector.js.map